import { MuiThemeProvider, makeStyles, createTheme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';


const theme = createTheme({

});

const useStyles = makeStyles(theme => ({

    badge: {
        paddingTop: 10,
        paddingRight: 24
    }
}));


// Missions are provided in a form suitable for the material table, so we need to count the ones with no parentId
const countAis = mp => {
    return Array.isArray(mp) && mp.length > 0 ? mp.length : 0;
}

const AisCounter = props => {

    const { data } = props;
    const classes = useStyles();

    return (
        <div className={classes.badge}>
            <MuiThemeProvider theme={theme}>
                <Tooltip title="Total ais">
                    <Badge badgeContent={countAis(data)} max={100000}  color="primary" overlap="rectangular">
                        <Typography noWrap variant="overline" display="block">{props.title}</Typography>
                    </Badge>
                </Tooltip>
            </MuiThemeProvider>
        </div>
    )
}

export default AisCounter;